// extracted by mini-css-extract-plugin
export default {"page":"CatalogPage_page__DQryD","catalog":"CatalogPage_catalog__fIqdc"};